<template>
    <MediaWithTextBlock
        kind="video"
        :asset-id="content?.video"
        :content="{ title: content?.title, body: content?.body, autoplays: content?.autoplays }"
        @enter="emit('enter')"
        @leave="emit('leave')"
    />
</template>

<script lang="ts" setup>
import MediaWithTextBlock from "~/components/view/MediaWithTextBlock.vue"

defineProps({
    content: {
        type: Object
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    }
})

const emit = defineEmits(['enter', 'leave'])
</script>
